<template>
    <div id="modals-box"></div>
    <ModalConfirm v-if="confirmIsShowed" />

    <template v-for="item in openedModals" :key="item.name">
        <template v-if="modalsComponents[item.name]">
            <component :is="modalsComponents[item.name]" :name="item.name" />
        </template>
    </template>
</template>

<script setup>
import { computed, onBeforeUnmount, defineAsyncComponent } from 'vue';

import ModalConfirm from '🔗/components/modals/ModalConfirm.vue';
import ModalLoader from '🔗/components/modals/ModalLoader.vue';
import ModalSuccess from '🔗/components/modals/ModalSuccess.vue';
import ModalReject from '🔗/components/modals/ModalReject.vue';
import ModalSelectTracks from './ModalSelectTracks.vue';
import ModalSelectReleases from './ModalSelectReleases.vue';
import ModalSelectPlaylists from './ModalSelectPlaylists.vue';
import ModalSelectArtists from './ModalSelectArtists.vue';
import ModalRelease from './ModalRelease.vue';
import ModalPlaylist from './ModalPlaylist.vue';

import { storeToRefs } from 'pinia';
// import stores from '@/stores';
const modals = stores.modals();

const { openedModals, confirmSettings, modalsComponents } = storeToRefs(modals);

const items = {
    loader: ModalLoader,
    success: ModalSuccess,
    reject: ModalReject,
    release: ModalRelease,
    playlist: ModalPlaylist,
    'select-tracks': ModalSelectTracks,
    'select-releases': ModalSelectReleases,
    'select-playlists': ModalSelectPlaylists,
    'select-artists': ModalSelectArtists
};

modals.register(items);

const confirmIsShowed = computed(() => !!confirmSettings.value);

onBeforeUnmount(() => {
    modals.unRegister(Object.keys(items));
});
</script>

<style scoped lang="scss">
    #modals-box {
        position: fixed;
        z-index: 2;
    }
</style>
